"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable-next-line:import-name

var rc_slider_1 = require("rc-slider");

var React = require("react"); // https://github.com/react-component/slider/ requires the css imported like this.
// tslint:disable-next-line:no-submodule-imports no-import-side-effect


require("rc-slider/assets/index.css");

var semantic_ui_react_1 = require("semantic-ui-react");
/**
 * Represents a simple 2d slider, allowing a value to be selected between a minimum and maximum.
 *
 * @export
 * @extends {React.Component<ChellSliderProps, IChellSliderState>}
 */


var ChellSlider =
/** @class */
function (_super) {
  __extends(ChellSlider, _super);

  function ChellSlider(props) {
    var _this = _super.call(this, props) || this;
    /**
     * Updates the state of the slider after user commits to change. If applicable, invokes appropriate callback.
     */


    _this.onAfterChange = function (cb) {
      return function (value) {
        if (cb) {
          cb(value);
        }

        _this.setState({
          value: value
        });
      };
    };
    /**
     * Updates the state of the slider as the user moves the slider around but before selection is committed.
     * If applicable, invokes appropriate callback as well.
     */


    _this.onChange = function (cb) {
      return function (value) {
        if (cb) {
          cb(value);
        }

        _this.setState({
          value: value
        });
      };
    };

    _this.onReset = function () {
      _this.onChange(_this.props.onChange)(_this.state.defaultValue); // this.onAfterChange(this.props.onAfterChange)(this.state.defaultValue);

    };

    _this.state = {
      defaultValue: props.defaultValue ? props.defaultValue : props.value,
      value: props.value
    };
    return _this;
  }

  ChellSlider.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        defaultValue = _a.defaultValue,
        value = _a.value;

    if (value && value !== prevProps.value) {
      this.setState({
        value: value
      });
    }

    var candidateDefaultValue = defaultValue ? defaultValue : value;

    if (this.state.defaultValue === -1 && candidateDefaultValue !== this.state.defaultValue) {
      this.setState({
        defaultValue: candidateDefaultValue
      });
    }
  };

  ChellSlider.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        value = _a.value,
        hideLabelValue = _a.hideLabelValue,
        max = _a.max,
        min = _a.min,
        label = _a.label,
        onAfterChange = _a.onAfterChange,
        onChange = _a.onChange,
        style = _a.style,
        remainingProps = __rest(_a, ["className", "value", "hideLabelValue", "max", "min", "label", "onAfterChange", "onChange", "style"]);

    return React.createElement(semantic_ui_react_1.Grid, {
      columns: 'equal',
      style: style,
      textAlign: 'left'
    }, React.createElement(semantic_ui_react_1.Grid.Column, {
      className: className
    }, !hideLabelValue && React.createElement("p", null, label + ": " + this.state.value), React.createElement(rc_slider_1.default, __assign({
      max: max,
      min: min,
      onAfterChange: this.onAfterChange(onAfterChange),
      onChange: this.onChange(onChange),
      value: value
    }, remainingProps))), React.createElement(semantic_ui_react_1.Grid.Column, {
      verticalAlign: 'middle',
      width: 2
    }, React.createElement(semantic_ui_react_1.Button, {
      icon: 'undo',
      onClick: this.onReset,
      size: 'small'
    })));
  };

  return ChellSlider;
}(React.Component);

exports.ChellSlider = ChellSlider;